import * as React from 'react';
import { PortalInputField } from 'components/FormControls';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Dispatch } from 'redux';
import { IStore } from 'redux/IStore';
import { searchOffices, setSearchFilter, setSearchFilterKeyword } from 'redux/modules/shop/offices';
import { IconName } from 'helpers/renderIcon';

type ReduxInjectedProps = Partial<ReturnType<typeof stateToProps> & ReturnType<typeof dispatchToProps>>;

interface IProps extends ReduxInjectedProps {
	t?: (key: string) => string;

	// To get non debounced updates
	inputChanged?: (value: string) => void;

	customIcon?: IconName;
	customIconWidth?: number;
	customIconHeight?: number;

	isLandingPage?: boolean;
}
interface IState {
	search: string;
}

const stateToProps = (state: IStore) => ({
	officesData: state.offices,
	userPreferences: state.userPreferences,
	shopTypeDomainValues: state.domainValues.shopType,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	setSearchFilter: (keyword: string) => dispatch(setSearchFilter(keyword)),
	setSearchFilterKeyword: (keyword: string) => dispatch(setSearchFilterKeyword(keyword)),
	searchOffices: (isFirstLoad: boolean, isRefinement: boolean) => dispatch(searchOffices(isFirstLoad, isRefinement)),
	dispatch,
});

@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SearchFilter extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			search: '',
		};
		this.handleSearchSalons = this.handleSearchSalons.bind(this);
	}

	private handleSearchSalons(value: string) {
		this.props.setSearchFilter(value);
	}

	render() {
		const { t, customIcon, customIconWidth, customIconHeight, isLandingPage } = this.props;

		return (
			<>
				{!isLandingPage ? (
					<PortalInputField
						type="text"
						usage="portal"
						iconName={customIcon ? customIcon : 'search1'}
						customIconSizeWidth={customIconWidth ? customIconWidth : 16}
						customIconSizeHeight={customIconHeight ? customIconHeight : 16}
						input={Object.assign(
							{
								// value: this.state.search,
								placeholder: t('Portal_Footer_Salons'),
							},
							this.props?.inputChanged
								? {
										onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
											this.props?.inputChanged?.(e?.currentTarget?.value);
										},
								  }
								: {},
						)}
						className={c.SHOPS_SEARCH_FILTER}
						highlightWhenValueSet={true}
						functionToTriggerOnSearch={this.handleSearchSalons}
						putSelectedValueInUrlQuery={c.SHOPS_SEARCH_FILTER}
						setUrlValueInternally={true}
					/>
				) : (
					<PortalInputField
						type="text"
						usage="portal"
						iconName={customIcon ? customIcon : 'search1'}
						customIconSizeWidth={customIconWidth ? customIconWidth : 16}
						customIconSizeHeight={customIconHeight ? customIconHeight : 16}
						input={Object.assign(
							{
								value: this.state.search,
								placeholder: t('Portal_Footer_Salons'),
							},
							this.props?.inputChanged
								? {
										onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
											this.props?.inputChanged?.(e?.currentTarget?.value);
										},
								  }
								: {},
						)}
						className={c.SHOPS_SEARCH_FILTER}
						highlightWhenValueSet={true}
					/>
				)}
			</>
		);
	}
}

export default SearchFilter;
